import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDarkMode } from '../../context/DarkModeContext';
import { CalendarIcon, StarIcon, FilterIcon, BookOpenIcon, ClockIcon } from 'lucide-react';
const ReadingHistory = () => {
  const {
    darkMode
  } = useDarkMode();
  const [filterYear, setFilterYear] = useState('2023');
  const history = [{
    id: 1,
    title: 'The Silent Echo',
    author: 'Elena Richards',
    cover: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
    rating: 5,
    dateRead: 'Oct 15, 2023',
    pages: 342
  }, {
    id: 2,
    title: 'Heart of the Storm',
    author: 'Marcus Chen',
    cover: 'https://images.unsplash.com/photo-1516979187457-637abb4f9353?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
    rating: 4,
    dateRead: 'Sep 28, 2023',
    pages: 410
  }, {
    id: 3,
    title: 'Whispers in the Dark',
    author: 'Sarah Johnson',
    cover: 'https://images.unsplash.com/photo-1598646506899-ac6be1060f4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
    rating: 4,
    dateRead: 'Sep 10, 2023',
    pages: 280
  }];
  return <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-8`} data-id="element-13013" data-mp="20x8wxhoqw5sy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13014" data-mp="2awq09sgiy7lr">
        <div className="flex justify-between items-center mb-8" data-id="element-13015" data-mp="2aw84sy1orxew">
          <h1 className="text-3xl font-bold" data-id="element-13016" data-mp="2exjoyo1sjqfp">Reading History</h1>
          <div className="flex items-center space-x-4" data-id="element-13017" data-mp="2evywd3z1ehkh">
            <select value={filterYear} onChange={e => setFilterYear(e.target.value)} className={`rounded-md border ${darkMode ? 'bg-gray-800 border-gray-700 text-white' : 'bg-white border-gray-300'} px-3 py-2`} data-id="element-13018" data-mp="2jqcrd59semom">
              <option value="2023" data-id="element-13019" data-mp="2ylso5i1r4wop">2023</option>
              <option value="2022" data-id="element-13020" data-mp="2ymkb64ha9m3d">2022</option>
              <option value="all" data-id="element-13021" data-mp="28xncivmqi0g7">All Time</option>
            </select>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-13022" data-mp="240epohqn588m">
          <div className={`p-6 rounded-lg shadow-sm ${darkMode ? 'bg-gray-800' : 'bg-white'}`} data-id="element-13023" data-mp="2ioi146ngdc4t">
            <div className="flex items-center" data-id="element-13024" data-mp="2dw8b6qmc8c2j">
              <div className="p-3 rounded-full bg-indigo-100 text-indigo-600" data-id="element-13025" data-mp="2dvf1bgs316g6">
                <BookOpenIcon className="h-6 w-6" data-id="element-13026" data-mp="2rmtp00wxpvtk" />
              </div>
              <div className="ml-4" data-id="element-13027" data-mp="2mos3l9c1dkex">
                <p className={`text-sm font-medium ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-13028" data-mp="2mro5f8r08t8n">
                  Books Read
                </p>
                <p className="text-2xl font-bold" data-id="element-13029" data-mp="2woiwx7ov1tdf">24</p>
              </div>
            </div>
          </div>
          <div className={`p-6 rounded-lg shadow-sm ${darkMode ? 'bg-gray-800' : 'bg-white'}`} data-id="element-13030" data-mp="17axejn8w2tzj">
            <div className="flex items-center" data-id="element-13031" data-mp="3dx3duj4luoo9">
              <div className="p-3 rounded-full bg-blue-100 text-blue-600" data-id="element-13032" data-mp="3dyeggfmbdqds">
                <FileTextIcon className="h-6 w-6" data-id="element-13033" data-mp="3iwfzx1nnjrps" />
              </div>
              <div className="ml-4" data-id="element-13034" data-mp="347a29i4gq9k0">
                <p className={`text-sm font-medium ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-13035" data-mp="3468t5j70bx4x">
                  Pages Read
                </p>
                <p className="text-2xl font-bold" data-id="element-13036" data-mp="2v6c9xx3dzqh9">8,432</p>
              </div>
            </div>
          </div>
          <div className={`p-6 rounded-lg shadow-sm ${darkMode ? 'bg-gray-800' : 'bg-white'}`} data-id="element-13037" data-mp="2z98l52qlkkb6">
            <div className="flex items-center" data-id="element-13038" data-mp="2l9z4k1yhbo6o">
              <div className="p-3 rounded-full bg-green-100 text-green-600" data-id="element-13039" data-mp="2q792k5zxp864">
                <ClockIcon className="h-6 w-6" data-id="element-13040" data-mp="2q9c3vm6jenq5" />
              </div>
              <div className="ml-4" data-id="element-13041" data-mp="jhkq5cv591v0">
                <p className={`text-sm font-medium ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-13042" data-mp="jf87exhkangw">
                  Avg. Rating
                </p>
                <p className="text-2xl font-bold" data-id="element-13043" data-mp="2kh6di8vp30so">4.2</p>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="space-y-6" data-id="element-13044" data-mp="2bht3nf3nsa7f">
          {history.map(book => <div key={book.id} className={`flex flex-col sm:flex-row p-6 rounded-lg shadow-sm ${darkMode ? 'bg-gray-800' : 'bg-white'}`} data-id="element-13045" data-mp="26jrmizpsmkyl">
              <div className="flex-shrink-0 mb-4 sm:mb-0 sm:mr-6" data-id="element-13046" data-mp="21m9b92oaztnf">
                <img src={book.cover} alt={book.title} className="w-24 h-36 object-cover rounded-md shadow-md" data-id="element-13047" data-mp="1ws52qeze3dk8" />
              </div>
              <div className="flex-1" data-id="element-13048" data-mp="1nukzj0hyv76z">
                <div className="flex justify-between items-start" data-id="element-13049" data-mp="1itx9ah1kaudt">
                  <div data-id="element-13050" data-mp="1it5dp67yswnj">
                    <h3 className="text-xl font-bold mb-1" data-id="element-13051" data-mp="1ivrodeq5js9z">
                      <Link to={`/book/${book.id}`} className="hover:text-indigo-600" data-id="element-13052" data-mp="1dvc9uju4weqf">
                        {book.title}
                      </Link>
                    </h3>
                    <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-2`} data-id="element-13053" data-mp="3b8t8526l477">
                      by {book.author}
                    </p>
                  </div>
                  <div className={`flex items-center text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-13054" data-mp="36shbgq0tm62g">
                    <CalendarIcon className="h-4 w-4 mr-1" data-id="element-13055" data-mp="3boeoongsewb0" />
                    {book.dateRead}
                  </div>
                </div>

                <div className="flex items-center mb-4" data-id="element-13056" data-mp="3kjckc2bbkn61">
                  <div className="flex text-yellow-400 mr-2" data-id="element-13057" data-mp="3kkxi00sxkm84">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < book.rating ? 'fill-current' : 'text-gray-300'}`} data-id="element-13058" data-mp="2s2jryndu64jl" data-mpi={i} />)}
                  </div>
                  <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-13059" data-mp="3qdl16suiip2f">
                    {book.pages} pages
                  </span>
                </div>

                <div className="flex space-x-3" data-id="element-13060" data-mp="3zjpobmpgmcu">
                  <Link to={`/book/${book.id}/reviews`} className="text-sm text-indigo-600 hover:text-indigo-500 font-medium" data-id="element-13061" data-mp="3cel8na3vpq0z">
                    Edit Review
                  </Link>
                  <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-13062" data-mp="3lh2xlwax4wro">
                    View Notes
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
// Helper component for icon
const FileTextIcon = ({
  className
}: {
  className?: string;
}) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-13063" data-mp="147801nhid2u8">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-13064" data-mp="196b7tfovhn5w" />
  </svg>;
export default ReadingHistory;